interface CodeEditorProps {
  value: string;
  onChange?: (value: string) => void;
  readOnly?: boolean;
  minHeight?: number;
  ariaLabel?: string;
}

/**
 * 代码编辑器（等宽字体 textarea 占位实现）。
 *
 * TODO(Monaco)：frontend/package.json 当前未登记 monaco-editor /
 * @monaco-editor/react 依赖。待依赖登记后，以相同的 props 接口将内部
 * 实现替换为 Monaco Editor，调用方（ArtifactEditor 等）无需改动。
 */
export default function CodeEditor({ value, onChange, readOnly, minHeight = 420, ariaLabel }: CodeEditorProps) {
  return (
    <textarea
      aria-label={ariaLabel}
      value={value}
      readOnly={readOnly}
      onChange={(e) => onChange?.(e.target.value)}
      spellCheck={false}
      style={{
        width: '100%',
        minHeight,
        fontFamily: "'JetBrains Mono', 'Fira Code', Consolas, 'Courier New', monospace",
        fontSize: 13,
        lineHeight: 1.6,
        tabSize: 2,
        whiteSpace: 'pre',
        overflowWrap: 'normal',
        overflow: 'auto',
        background: 'var(--bg-primary)',
        color: 'var(--text-primary)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
        padding: 12,
        resize: 'vertical',
      }}
    />
  );
}
